import React from 'react';
import { Link } from 'react-router-dom';
import { GitBranch, Link2, Mail } from 'lucide-react';
// ArrowUpRight import removed with the Tutorials column below — re-add it when re-enabling that block

const Footer: React.FC = () => (
  <footer style={{
    borderTop: '1px solid var(--border)',
    padding: '48px 24px',
    marginTop: 80,
  }}>
    <div style={{
      maxWidth: 1200, margin: '0 auto',
      display: 'grid', gridTemplateColumns: '1fr auto', gap: 32,
      alignItems: 'start',
    }}>
      <div>
        <div style={{ fontFamily: 'var(--font-display)', fontWeight: 800, fontSize: 20, marginBottom: 8 }}>
          Parmeshwar
        </div>
        <p style={{ color: 'var(--text2)', fontSize: 14, maxWidth: 360, marginBottom: 20 }}>
          Senior Full Stack Developer · IIT Indore · Delhi, India
        </p>
        <div style={{ display: 'flex', gap: 12 }}>
          {[
            { icon: GitBranch, href: 'https://github.com/PARMESHWARPANWAR', label: 'GitHub' },
            { icon: Link2, href: 'https://linkedin.com/in/parmeshwar777', label: 'LinkedIn' },
            { icon: Mail, href: 'mailto:parmeshwarpanwar777@gmail.com', label: 'Email' },
          ].map(({ icon: Icon, href, label }) => (
            <a key={label} href={href} target="_blank" rel="noopener noreferrer"
              style={{
                width: 38, height: 38, borderRadius: 10, border: '1px solid var(--border2)',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                color: 'var(--text2)', transition: 'all 0.2s',
              }}
              onMouseOver={e => { e.currentTarget.style.color = 'var(--cyan)'; e.currentTarget.style.borderColor = 'rgba(0,229,200,0.3)'; }}
              onMouseOut={e => { e.currentTarget.style.color = 'var(--text2)'; e.currentTarget.style.borderColor = 'var(--border2)'; }}
            ><Icon size={16} /></a>
          ))}
        </div>
      </div>
      <div style={{ display: 'flex', gap: 48, flexWrap: 'wrap' }}>
        <div>
          <div style={{ fontSize: 11, fontFamily: 'var(--font-mono)', color: 'var(--text3)', letterSpacing: '0.1em', textTransform: 'uppercase', marginBottom: 14 }}>Navigation</div>
          {[
            ['/', 'Home'], ['/about', 'About'], ['/notes', 'Notes'],
            // Hidden until there's more published content — re-enable when ready to show
            // ['/projects', 'Projects'], // duplicates Home's Featured Work section
            // ['/blog', 'Blog'],
          ].map(([href, label]) => (
            <div key={href} style={{ marginBottom: 8 }}>
              <Link to={href} style={{ fontSize: 14, color: 'var(--text2)', transition: 'color 0.2s' }}
                onMouseOver={e => e.currentTarget.style.color = 'var(--text)'}
                onMouseOut={e => e.currentTarget.style.color = 'var(--text2)'}
              >{label}</Link>
            </div>
          ))}
        </div>
        {/* Tutorials footer column — hidden until the React/Python roadmaps have more published content, re-enable when ready to show
        <div>
          <div style={{ fontSize: 11, fontFamily: 'var(--font-mono)', color: 'var(--text3)', letterSpacing: '0.1em', textTransform: 'uppercase', marginBottom: 14 }}>Tutorials</div>
          {[['/react', 'React'], ['/python', 'Python / AI']].map(([href, label]) => (
            <div key={href} style={{ marginBottom: 8 }}>
              <Link to={href} style={{ fontSize: 14, color: 'var(--text2)', display: 'flex', alignItems: 'center', gap: 4, transition: 'color 0.2s' }}
                onMouseOver={e => e.currentTarget.style.color = 'var(--cyan)'}
                onMouseOut={e => e.currentTarget.style.color = 'var(--text2)'}
              >{label} <ArrowUpRight size={12} /></Link>
            </div>
          ))}
        </div>
        */}
      </div>
    </div>
    <div style={{ maxWidth: 1200, margin: '32px auto 0', paddingTop: 24, borderTop: '1px solid var(--border)', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 8 }}>
      <span style={{ fontSize: 13, color: 'var(--text3)' }}>© 2025 Parmeshwar</span>
      <span style={{ fontSize: 13, color: 'var(--text3)', fontFamily: 'var(--font-mono)' }}>Delhi, India 🇮🇳</span>
    </div>
  </footer>
);

export default Footer;
